
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/factory",
      function () {
        return require("private-next-pages/factory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/factory"])
      });
    }
  